module.exports = __webpack_public_path__ + "assets/img/time.2303fe3b.svg";